import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  HStack,
  Image,
  Icon,
} from "@chakra-ui/react";
import { FaMapMarkerAlt, FaPhone, FaEnvelope } from "react-icons/fa";
import { NavbarWithCallToAction } from "../components/chakra/NavbarWithCallToAction/NavbarWithCallToAction";
import { FooterWithFourColumns } from "../components/chakra/FooterWithFourColumns/FooterWithFourColumns";
import { getColor } from "../brandConfig";
import { VapiFloatingCallButton } from "../components/VapiFloatingCallButton";

const ContactPage = () => {
  return (
    <>
      <NavbarWithCallToAction />

      <Box
        bg={getColor("background.main")}
        minHeight="100vh"
        position="relative"
        overflow="hidden"
        _before={{
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: `
          radial-gradient(60% 60% at 0% 0%, #112334 0%, transparent 50%),
          radial-gradient(50% 50% at 50% 50%, #369eff33 0%, transparent 100%)
        `,
          pointerEvents: 'none',
          zIndex: 0,
        }}
        sx={{
          '@keyframes snowfall': {
            '0%': {
              transform: 'translateX(-200px) translateY(-100px)',
              opacity: 0,
            },
            '5%': {
              opacity: 0.4,
            },
            '25%': {
              transform: 'translateX(25vw) translateY(25vh)',
              opacity: 0.8,
            },
            '50%': {
              transform: 'translateX(50vw) translateY(50vh)',
              opacity: 1,
            },
            '75%': {
              transform: 'translateX(75vw) translateY(75vh)',
              opacity: 0.8,
            },
            '95%': {
              opacity: 0.4,
            },
            '100%': {
              transform: 'translateX(calc(100vw + 200px)) translateY(100vh)',
              opacity: 0,
            }
          },
          '@keyframes snowfall-slow': {
            '0%': {
              transform: 'translateX(-250px) translateY(-100px)',
              opacity: 0,
            },
            '5%': {
              opacity: 0.3,
            },
            '30%': {
              transform: 'translateX(35vw) translateY(30vh)',
              opacity: 0.6,
            },
            '60%': {
              transform: 'translateX(65vw) translateY(60vh)',
              opacity: 0.8,
            },
            '95%': {
              opacity: 0.3,
            },
            '100%': {
              transform: 'translateX(calc(100vw + 250px)) translateY(100vh)',
              opacity: 0,
            }
          },
          '@keyframes snowfall-medium': {
            '0%': {
              transform: 'translateX(-180px) translateY(-100px)',
              opacity: 0,
            },
            '8%': {
              opacity: 0.5,
            },
            '40%': {
              transform: 'translateX(45vw) translateY(40vh)',
              opacity: 0.9,
            },
            '70%': {
              transform: 'translateX(80vw) translateY(70vh)',
              opacity: 0.7,
            },
            '92%': {
              opacity: 0.4,
            },
            '100%': {
              transform: 'translateX(calc(100vw + 180px)) translateY(100vh)',
              opacity: 0,
            }
          },
          '&::after': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: '-10%',
            width: '120%',
            height: '100%',
            backgroundImage: `
            radial-gradient(3px 3px at 10% 10%, rgba(255,255,255,0.6) 50%, transparent 50%),
            radial-gradient(4px 4px at 20% 30%, rgba(255,255,255,0.5) 50%, transparent 50%),
            radial-gradient(2px 2px at 15% 50%, rgba(255,255,255,0.7) 50%, transparent 50%),
            radial-gradient(5px 5px at 25% 20%, rgba(255,255,255,0.4) 50%, transparent 50%),
            radial-gradient(3px 3px at 30% 60%, rgba(255,255,255,0.6) 50%, transparent 50%),
            radial-gradient(6px 6px at 35% 40%, rgba(255,255,255,0.3) 50%, transparent 50%),
            radial-gradient(4px 4px at 40% 70%, rgba(255,255,255,0.5) 50%, transparent 50%),
            radial-gradient(2px 2px at 45% 15%, rgba(255,255,255,0.8) 50%, transparent 50%),
            radial-gradient(5px 5px at 50% 80%, rgba(255,255,255,0.4) 50%, transparent 50%)
          `,
            backgroundSize: '400px 400px, 500px 500px, 350px 350px, 450px 450px, 550px 550px, 600px 600px, 480px 480px, 420px 420px, 520px 520px',
            backgroundPosition: '0 0, 80px 60px, 160px 40px, 240px 100px, 320px 160px, 400px 80px, 480px 200px, 560px 20px, 640px 180px',
            animation: 'snowfall 25s linear infinite',
            pointerEvents: 'none',
            zIndex: 1,
          }
        }}
      >
        <Box
          position="absolute"
          top={0}
          left={0}
          right={0}
          bottom={0}
          pointerEvents="none"
          zIndex={1}
        >
          <Box
            position="absolute"
            top={0}
            left="-20%"
            width="140%"
            height="100%"
            opacity={0.6}
            sx={{
              backgroundImage: `
              radial-gradient(5px 5px at 5% 15%, rgba(255,255,255,0.4) 50%, transparent 50%),
              radial-gradient(3px 3px at 15% 35%, rgba(255,255,255,0.5) 50%, transparent 50%),
              radial-gradient(7px 7px at 10% 55%, rgba(255,255,255,0.3) 50%, transparent 50%),
              radial-gradient(4px 4px at 20% 25%, rgba(255,255,255,0.6) 50%, transparent 50%),
              radial-gradient(8px 8px at 25% 45%, rgba(255,255,255,0.25) 50%, transparent 50%),
              radial-gradient(6px 6px at 30% 65%, rgba(255,255,255,0.45) 50%, transparent 50%),
              radial-gradient(3px 3px at 35% 20%, rgba(255,255,255,0.7) 50%, transparent 50%)
            `,
              backgroundSize: '600px 600px, 700px 700px, 550px 550px, 650px 650px, 750px 750px, 680px 680px, 580px 580px',
              backgroundPosition: '0 0, 120px 140px, 240px 80px, 360px 200px, 480px 280px, 600px 120px, 720px 40px',
              animation: 'snowfall-slow 35s linear infinite',
            }}
          />

          <Box
            position="absolute"
            top={0}
            left="-15%"
            width="130%"
            height="100%"
            opacity={0.5}
            sx={{
              backgroundImage: `
              radial-gradient(4px 4px at 8% 20%, rgba(255,255,255,0.5) 50%, transparent 50%),
              radial-gradient(6px 6px at 18% 40%, rgba(255,255,255,0.35) 50%, transparent 50%),
              radial-gradient(3px 3px at 12% 60%, rgba(255,255,255,0.6) 50%, transparent 50%),
              radial-gradient(5px 5px at 22% 30%, rgba(255,255,255,0.4) 50%, transparent 50%),
              radial-gradient(7px 7px at 28% 50%, rgba(255,255,255,0.3) 50%, transparent 50%),
              radial-gradient(4px 4px at 32% 70%, rgba(255,255,255,0.55) 50%, transparent 50%)
            `,
              backgroundSize: '550px 550px, 650px 650px, 500px 500px, 600px 600px, 700px 700px, 580px 580px',
              backgroundPosition: '50px 30px, 150px 150px, 250px 90px, 350px 210px, 450px 270px, 550px 150px',
              animation: 'snowfall-medium 30s linear infinite',
            }}
          />
        </Box>

        <Box
          position="relative"
          width="100vw"
          height="624px"
          overflow="hidden"
          marginLeft="50%"
          transform="translateX(-50%)"
          backgroundImage="url('/assets/onesolarimages/abouthero.jpg')"
          backgroundSize="cover"
          backgroundPosition="center"
          backgroundRepeat="no-repeat"
        >
          <Box
            position="absolute"
            top={0}
            left={0}
            right={0}
            bottom={0}
            bg="rgba(0, 0, 0, 0.5)"
            zIndex={1}
          />

          <Container
            maxW="1200px"
            position="relative"
            zIndex={2}
            height="100%"
            display="flex"
            alignItems="center"
          >
            <Box
              width="100%"
              textAlign="center"
              color="white"
            >
              <Heading
                as="h1"
                fontSize={{ base: "4xl", md: "5xl", lg: "6xl" }}
                fontWeight="bold"
                textShadow="2px 2px 4px rgba(0,0,0,0.5)"
                fontFamily="'Open Sans', sans-serif"
                textTransform="uppercase"
              >
                Contact Us
              </Heading>
            </Box>
          </Container>
        </Box>

        <Box
          bg="white"
          py={{ base: 16, md: 20 }}
          position="relative"
        >
          <Container maxW="1200px">
            <VStack spacing={12} align="stretch">
              <Box width="60px" height="2px" bg="#121c47" />

              <Heading
                as="h4"
                fontSize={{ base: "sm", md: "md" }}
                fontWeight="600"
                textTransform="uppercase"
                letterSpacing="wider"
                color="#121c47"
                fontFamily="'Open Sans', sans-serif"
              >
                GET IN TOUCH
              </Heading>

              <Heading
                as="h1"
                fontSize={{ base: "2xl", md: "3xl", lg: "4xl" }}
                fontWeight="bold"
                textAlign="left"
                color="#050303"
                textTransform="uppercase"
                fontFamily="'Open Sans', sans-serif"
                maxW="900px"
              >
                WE'D LOVE TO HEAR FROM YOU
              </Heading>
              <Box
                bg="white"
                borderRadius="lg"
                boxShadow="lg"
                overflow="hidden"
                minHeight="900px"
              >
                <iframe
                  src="https://api.leadconnectorhq.com/widget/form/kxni0J3DQQqxmIfmpHUR"
                  style={{
                    width: '100%',
                    height: '900px',
                    border: 'none',
                    borderRadius: '3px'
                  }}
                  id="inline-kxni0J3DQQqxmIfmpHUR"
                  data-layout="{'id':'INLINE'}"
                  data-trigger-type="alwaysShow"
                  data-trigger-value=""
                  data-activation-type="alwaysActivated"
                  data-activation-value=""
                  data-deactivation-type="neverDeactivate"
                  data-deactivation-value=""
                  data-form-name="Contact Form"
                  data-height="900"
                  data-layout-iframe-id="inline-kxni0J3DQQqxmIfmpHUR"
                  data-form-id="kxni0J3DQQqxmIfmpHUR"
                  title="Contact Form"
                />
              </Box>

              <Box
                bg="white"
                p={8}
                borderRadius="lg"
                boxShadow="md"
              >
                <HStack spacing={8} align="stretch" flexDirection={{ base: "column", md: "row" }}>
                  <Box flex={1}>
                    <VStack spacing={6} align="stretch">
                      <HStack spacing={4} align="flex-start">
                        <Icon as={FaMapMarkerAlt} w={6} h={6} color="#121c47" mt={1} />
                        <Box>
                          <Text fontWeight="bold" fontSize="lg" mb={2} fontFamily="'Open Sans', sans-serif">
                            Our Address
                          </Text>
                          <Text color="gray.600" fontFamily="'Open Sans', sans-serif">
                            21c Somerset Street<br />
                            Frankton, Hamilton<br />
                            New Zealand
                          </Text>
                        </Box>
                      </HStack>

                      <HStack spacing={4} align="flex-start">
                        <Icon as={FaPhone} w={6} h={6} color="#121c47" mt={1} />
                        <Box>
                          <Text fontWeight="bold" fontSize="lg" mb={2} fontFamily="'Open Sans', sans-serif">
                            Toll Free Number
                          </Text>
                          <Text color="gray.600" fontFamily="'Open Sans', sans-serif">
                            0800 767 024
                          </Text>
                        </Box>
                      </HStack>

                      <Box>
                        <Text fontWeight="bold" fontSize="lg" mb={2} fontFamily="'Open Sans', sans-serif" ml={10}>
                          Company Number
                        </Text>
                        <Text color="gray.600" fontFamily="'Open Sans', sans-serif" ml={10}>
                          9372605
                        </Text>
                      </Box>
                    </VStack>
                  </Box>

                  <Box flex={1} display="flex" justifyContent="center" alignItems="center">
                    <Box
                      as="iframe"
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1610588.71809782!2d173.3591626790482!3d-37.96123172694778!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6d6d23b6a3380f81%3A0xbd5e6ece5725dac5!2sOne%20Solar%20NZ!5e0!3m2!1sen!2sau!4v1761224648648!5m2!1sen!2sau"
                      width={{ base: "400px", md: "600px" }}
                      height={{ base: "300px", md: "450px" }}
                      border="0"
                      allowFullScreen
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                      borderRadius="md"
                    />
                  </Box>
                </HStack>
              </Box>
            </VStack>
          </Container>
        </Box>
      </Box>

      <FooterWithFourColumns />
      <VapiFloatingCallButton />
    </>
  );
};

export default ContactPage;